<template>
  <div class="why-choose-section">
    <!-- 标题区域 -->
    <div class="header">
      <div class="tag">CAPABILITY ASSESSMENT</div>
      <h2 class="title">Why Choose <span class="gradient">Fraud Counsel Department</span></h2>

      <!-- 居中带分割线的装饰 -->
      <div class="divider-container">
        <div class="line"></div>
        <span class="square-icon">[■]</span>
        <div class="line"></div>
      </div>
    </div>

    <!-- 卡片网格 -->
    <div class="grid">
      <div v-for="(item, index) in reasons" :key="index" class="card">
        <!-- 四角的断线边框 (左上和右下) -->
        <span class="corner tl"></span>
        <span class="corner br"></span>

        <!-- 图标 -->
        <div class="icon-box">
          <span class="icon">{{ item.icon }}</span>
        </div>

        <!-- 标题和描述 -->
        <h3 class="card-title">{{ item.title }}</h3>
        <p class="card-desc">{{ item.desc }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhyChooseUs',
  data() {
    return {
      reasons: [
        {
          icon: '🔍',
          title: 'Advanced Blockchain Intelligence',
          desc: 'We deploy cutting-edge blockchain analytics to trace stolen assets across multiple networks, wallets, and exchange layers with surgical precision.'
        },
        {
          icon: '🛡️',
          title: 'Evidence-Based Methodology',
          desc: 'Every case is handled with a strict evidence-first approach — documentation, chain of custody, and forensic integrity are maintained throughout the entire process.'
        },
        {
          icon: '⚖️',
          title: 'Legal Enforcement Alignment',
          desc: 'We work directly with international law enforcement, cybercrime units, and regulatory bodies to strengthen recovery outcomes for every client we serve.'
        },
        {
          icon: '🌐',
          title: 'Global Cross-Border Reach',
          desc: 'Our international network allows us to pursue criminals across jurisdictions — wherever the blockchain trail leads, our team will follow it without exception.'
        },
        {
          icon: '🔒',
          title: 'Strict Confidentiality',
          desc: 'All case data, communications, and evidence are encrypted and handled under the highest data-protection standards. Your privacy is fully guaranteed at every stage.'
        },
        {
          icon: '⏱️',
          title: '24/7 Case Monitoring',
          desc: 'Our operations centre monitors blockchain activity around the clock, providing real-time updates and instant response when critical evidence emerges during your case.'
        }
      ]
    };
  }
}
</script>

<style scoped>
.why-choose-section {
  background-color: #070b14;
  padding: 100px 5%;
  color: #fff;
}

/* 标题区域（靠左对齐） */
.header {
  max-width: 1400px;
  margin: 0 auto 60px;
  text-align: left;
}

.tag {
  color: #00ff88;
  font-size: 0.85rem;
  letter-spacing: 2px;
  margin-bottom: 20px;
  text-transform: uppercase;
  font-weight: 600;
}

.title {
  font-size: 3.5rem;
  font-weight: 800;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #00ff88, #4fd1c5);
  -webkit-background-clip: text;
  color: transparent;
}

/* 居中装饰线 */
.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.15);
}

.divider-container .square-icon {
  color: #00ff88;
  font-size: 0.9rem;
  font-family: monospace;
  margin: 0 15px;
}

/* 卡片网格布局 */
.grid {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
}

/* 卡片基础样式 */
.card {
  position: relative;
  background: rgba(10, 15, 28, 0.8);
  border: 1px solid rgba(37, 48, 69, 0.8);
  border-radius: 10px;
  padding: 35px 30px;
  transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  border-color: #00ff88;
  box-shadow: 0 10px 30px rgba(0, 255, 136, 0.1);
}

/* 四角折线 */
.corner {
  position: absolute;
  width: 15px;
  height: 15px;
  border: 2px solid #00ff88;
}

.tl {
  top: -1px;
  left: -1px;
  border-right: none;
  border-bottom: none;
}

.br {
  bottom: -1px;
  right: -1px;
  border-left: none;
  border-top: none;
}

/* 图标盒子 */
.icon-box {
  width: 50px;
  height: 50px;
  background: #0a101f;
  border: 1px solid #253045;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
}

.icon {
  font-size: 1.8rem;
}

/* 标题和描述 */
.card-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 15px;
  color: #fff;
}

.card-desc {
  color: #9fb0c8;
  font-size: 1rem;
  line-height: 1.7;
  margin: 0;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2.5rem;
  }

  .grid {
    grid-template-columns: 1fr;
  }

  .card {
    padding: 25px;
  }
}
</style>